import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { useService } from 'react-service-locator';
import Animate from 'rc-animate';
import { Icon } from 'src/components/general/icon';
import {
  SidebarMenuItem,
  SidebarSubMenu,
} from 'src/components/layout/authenticated-layout/sidebar/menu/menu-items';
import {
  SidebarMenuProps,
  StyledMenu,
} from 'src/components/layout/authenticated-layout/sidebar/menu/shared';
import { useAuthorization } from 'src/hooks/use-authorization';
import { SidebarService } from 'src/services/sidebar.service';

export const AgencyMenu = memo<SidebarMenuProps>((props) => {
  const { hasPermission } = useAuthorization();
  const sidebarService = useService(SidebarService, (s) => [s.state.isCollapsed]);
  const {
    state: { isCollapsed: sidebarIsCollapsed },
  } = sidebarService;

  const { url: institutionUrl } = useRouteMatch();
  const { t } = useTranslation(['common']);

  return (
    <StyledMenu {...props}>
      {hasPermission('platform:agency.organization:access') && (
        <SidebarMenuItem
          icon="sidebarorganization"
          to={`${institutionUrl}/organizations/`}
          key={`${institutionUrl}/organizations/`}
          label={t('common:sidebar.organizations')}
        />
      )}
      {hasPermission('platform:agency:access') && (
        <SidebarSubMenu
          key={`${institutionUrl}/reports/`}
          to={`${institutionUrl}/reports/`}
          subMenuSelectedKeys={props.selectedKeys}
          icon="reports"
          title={
            <React.Fragment>
              <span>{t('common:sidebar.reports')}</span>
              <Animate transitionName="ant-fade">
                {!sidebarIsCollapsed && <Icon type="dropdown" className="lgg-arrow" />}
              </Animate>
            </React.Fragment>
          }
        >
          <SidebarMenuItem
            to={`${institutionUrl}/reports/usage/`}
            key={`${institutionUrl}/reports/usage/`}
            label={t('common:sidebar.usage')}
          />
        </SidebarSubMenu>
      )}
      {hasPermission('platform:agency.user:access') && (
        <SidebarMenuItem
          to={`${institutionUrl}/accounts/`}
          key={`${institutionUrl}/accounts/`}
          icon="accounts"
          label={t('common:sidebar.accounts')}
        />
      )}
      {hasPermission('platform:agency:update') && (
        <SidebarMenuItem
          to={`${institutionUrl}/settings/`}
          key={`${institutionUrl}/settings/`}
          icon="settings"
          label={t('common:sidebar.settings')}
        />
      )}
    </StyledMenu>
  );
});
